import { HTMLAttributes, ReactNode, useId } from 'react';
import { ResourceEmptyState, SectionWithHeader } from '../../ui';
import { TypographyVariants } from '../../atoms/typography/variants';

type Props<T> = {
  title: string;
  titleSize?: TypographyVariants['variant'];
  items: Array<T>;
  action?: ReactNode;
  resource?: string;
  render: (item: T, index: number) => ReactNode;
} & Omit<HTMLAttributes<HTMLDivElement>, 'children'>;

export function CardList<T>(props: Props<T>) {
  const id = useId();

  const {
    title,
    titleSize = 'body-s',
    items,
    action,
    resource,
    render,
    className,
    ...rest
  } = props;

  return (
    <SectionWithHeader
      title={title}
      action={action}
      titleSize={titleSize}
      {...rest}
    >
      {items.length === 0 && resource ? (
        <ResourceEmptyState message={`Er zijn geen ${resource}`} />
      ) : (
        <ul className="space-y-12">
          {items.map((item, index) => {
            return (
              <li key={`card-list-${id}-item-${index}`} className="">
                {render(item, index)}
              </li>
            );
          })}
        </ul>
      )}
    </SectionWithHeader>
  );
}
